import { classNames } from 'shared/lib/classNames/classNames';
import React, { ReactNode, useEffect, useState } from 'react';
import { TransactionClosedCard } from './ui/TransactionClosedCard/TransactionClosedCard';
import { TransactionOpenCard } from './ui/TransactionOpenCard/TransactionOpenCard';
import { TransactionSum } from './ui/TransactionSum/TransactionSum';
import { TransactionHistory } from './ui/TransactionHistory/TransactionHistory';
import { useApi } from 'app/api/APIProvider';

export enum TransactionCardsTheme {
    closed = 'closed',
    open = 'open',
    history = 'history',
    sum = 'sum',
}

interface TransactionCardsProps {
    transaction?: any,
    sum?: number | string,
    balanceText?: string,
    showPercentage?: boolean,
    detail?: boolean,
    theme: TransactionCardsTheme,
}

export const TransactionCards = ({ transaction, detail, sum, balanceText, showPercentage, theme }: TransactionCardsProps) => {
    const api = useApi();

    return (
        <>
            {
                theme === 'open' && <TransactionOpenCard transaction={transaction} />
            }
            {
                theme === 'closed' && <TransactionClosedCard detail={detail} transaction={transaction} showPercentage={showPercentage} />
            }
            {
                theme === 'history' && <TransactionHistory transaction={transaction} />
            }
            {
                theme === 'sum' && <TransactionSum  balanceText={balanceText} sum={sum} />
            }
        </>
    );
};
